module.exports = __webpack_public_path__ + "media/greenhouse-fullhd04.f4e5d203.mp4";